import { Flex, Image, Text } from "@chakra-ui/react"

import React from "react"

interface Props {
  logo: string
  label: string
  isSelected?: boolean
  className?: string
  onClick: () => void
}

const CloudProviderSelectionButtonMobile: React.FC<Props> = ({
  logo,
  label,
  onClick,
  className,
  isSelected = false,
}) => {
  return (
    <Flex
      className={className}
      flexDirection="row"
      position="relative"
      py={2}
      px={4}
      borderWidth={1}
      borderColor={isSelected ? "blackAlpha.200" : "transparent"}
      backgroundColor={isSelected ? "blackAlpha.50" : "transparent"}
      borderRadius="md"
      cursor="pointer"
      alignItems="center"
      onClick={onClick}
      overflow="hidden"
      transition="all 0.3s ease-in-out"
    >
      <Image src={logo} alt={label} boxSize="24px" />
      <Text
        fontWeight="bold"
        opacity={isSelected ? 1 : 0}
        maxWidth={isSelected ? "200px" : "0px"}
        ml={isSelected ? 3 : 0}
        transition="all 0.3s ease-in-out"
        whiteSpace="nowrap"
        overflow="hidden"
      >
        {label}
      </Text>
    </Flex>
  )
}

export default CloudProviderSelectionButtonMobile
